import Vue from "vue";
import VueRouter from "vue-router";
import { Service } from "typedi";
import { AppModule } from "@/core/types/app-module";
import { CoreSymbols } from "@/core/core.symbols";
import { routes } from "./applications.routes";

@Service()
export class ApplicationsModule implements AppModule {
  public install(vue: typeof Vue): Promise<void> | void {
    const router = vue.$container.get<VueRouter>(CoreSymbols.router);

    routes.forEach((route) => router.addRoute(route));
  }
}
